const NAMESPACE = "editEligibilityConditionDialog";

const KEYS = {
    dataFieldSearchListLabel: "dataFieldSearchListLabel",
    selectedDataFieldNameLabel: "selectedDataFieldNameLabel",
    noSelectableDataFieldsMessage: "noSelectableDataFieldsMessage",
    selectDataFieldButtonLabel: "selectDataFieldButtonLabel",
    conditionOperatorSelectorLabel: "conditionOperatorSelectorLabel",
    genericNoSelectionOption: "genericNoSelectionOption",
    operandTextInputAltLabel: "operandTextInputAltLabel",
    operandDateInputAltLabel: "operandDateInputAltLabel",
    operandBooleanSelectorAltLabel: "operandBooleanSelectorAltLabel",
    operandOptionTrueLabel: "operandOptionTrueLabel",
    operandOptionFalseLabel: "operandOptionFalseLabel",
    dataFieldErrorMessage: "dataFieldErrorMessage",
    operandChoiceErrorMessage: "operandChoiceErrorMessage",
    operandBooleanErrorMessage: "operandBooleanErrorMessage",
    operandValueErrorMessage: "operandValueErrorMessage"
};

const MESSAGES = {
    [KEYS.dataFieldSearchListLabel]: {
        value: "Base the Condition on this Data Field:",
        comment: "Label for the Data Field search list"
    },
    [KEYS.selectedDataFieldNameLabel]: {
        value: "The Condition is Based on this Data Field:",
        comment: "Label for the Condition Data Field selector"
    },
    [KEYS.noSelectableDataFieldsMessage]: {
        value: "No data field names match the input search filter.",
        comment: "Message displayed when no data field names match the input search filter"
    },
    [KEYS.selectDataFieldButtonLabel]: {
        value: "Select a Different Data Field",
        comment: "Text for the button used to make a different data field selection"
    },
    [KEYS.conditionOperatorSelectorLabel]: {
        value: "The incentive will be available to a project if the value of this data field",
        comment: "Label for the Condition Operator selector"
    },
    [KEYS.genericNoSelectionOption]: {
        value: "Select...",
        comment: "Label when no selection has been made in a dropdown list"
    },
    [KEYS.operandTextInputAltLabel]: {
        value: "Input a value for the data field",
        comment: "Alt-label for the data field value input"
    },
    [KEYS.operandDateInputAltLabel]: {
        value: "Select a date value for the data field",
        comment: "Alt-label for the date selector"
    },
    [KEYS.operandBooleanSelectorAltLabel]: {
        value: "True and False options for a checkbox data field",
        comment: "Alt-label for a boolean value selection"
    },
    [KEYS.operandOptionTrueLabel]: {
        value: "True (its checkbox is checked)",
        comment: "Label for the boolean True option checkbox"
    },
    [KEYS.operandOptionFalseLabel]: {
        value: "False (its checkbox is unchecked)",
        comment: "Label for the boolean False option checkbox"
    },
    [KEYS.dataFieldErrorMessage]: {
        value: "A data field must be selected.",
        comment: "Error message displayed if no data field has been selected"
    },
    [KEYS.operandChoiceErrorMessage]: {
        value: "At least one option must be selected.",
        comment: "Error message displayed if no multiple choice option has been selected"
    },
    [KEYS.operandBooleanErrorMessage]: {
        value: "An option must be selected.",
        comment: "Error message displayed if no boolean (True/False) option has been selected"
    },
    [KEYS.operandValueErrorMessage]: {
        value: "A value is required.",
        comment: "Error message displayed if no data field value has been input."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
